/** @file Canvas snapshot utility. */

/**
 * @param {{ width(): number, toDataURL(opts: object): string }} stage
 * @returns {string}
 */
export function captureThumbnail(stage) {
  const w = stage.width();
  const pixelRatio = w > 0 ? Math.min(1, 320 / w) : 1;
  return stage.toDataURL({ mimeType: "image/png", quality: 0.6, pixelRatio });
}
